export interface DocumentVersion {
  version: string;
  date: string;
  label: string;
  changelog?: string;
}

export interface LegalDocumentProps {
  onVersionChange?: (version: string) => void;
  currentVersion?: string;
}

export const TERMS_VERSIONS: DocumentVersion[] = [
  {
    version: '1.0',
    date: '2025-01-20',
    label: 'v1.0 - 20 de Janeiro de 2025',
    changelog: 'Versão inicial dos Termos de Uso'
  }
];

export const GUIDELINES_VERSIONS: DocumentVersion[] = [
  {
    version: '1.0',
    date: '2025-01-20',
    label: 'v1.0 - 20 de Janeiro de 2025',
    changelog: 'Versão inicial das Diretrizes da Comunidade'
  }
];

export const PRIVACY_VERSIONS: DocumentVersion[] = [
  {
    version: '1.0',
    date: '2025-01-20',
    label: 'v1.0 - 20 de Janeiro de 2025',
    changelog: 'Versão inicial da Política de Privacidade'
  }
];
